import { agentsColumns } from './agentProductionConstants';

export const transactionCoveragePDFColumns = Object.freeze({
    rank: agentsColumns.rank,
    area: agentsColumns.area,
    totalUnits: {...agentsColumns.totalUnits, label: '# Listings'},
    totalVolume: {...agentsColumns.totalVolume, label: 'Total $' },
    totalUnitsPct: { ...agentsColumns.totalUnitsPct, label: 'Units %' },
    totalVolumePct: { ...agentsColumns.totalVolumePct, label: '$ Volume %' },
});
